import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getAllChecklistGroups } from 'core/API/checklist';
import { getAssignmentGroupIdsForUser } from 'core/utils/assignmentGroupMembership';
import { useUserData } from 'store/useUserData';

export function useUserAssignmentGroupIds(workplaceId: number | undefined, enabled = true) {
	const { currentUserRole } = useUserData();
	const currentUserId = Number(localStorage.getItem('userId')) || null;
	const currentSecurityRoleId = currentUserRole?.id ?? null;

	const { data: groups = [], isLoading } = useQuery(
		['checklist-assignment-groups', workplaceId],
		() => getAllChecklistGroups(),
		{
			enabled: enabled && !!workplaceId,
			staleTime: 5 * 60 * 1000,
		}
	);

	const userGroupIds = useMemo(
		() => getAssignmentGroupIdsForUser(groups, currentUserId, currentSecurityRoleId),
		[groups, currentUserId, currentSecurityRoleId]
	);

	return { userGroupIds, isLoading };
}
